import React, { Component } from 'react'
import { ArtworkStatic } from 'api'
import { truncate } from 'underscore.string'

import { List } from 'components'
import { Artwork } from 'api/entity-schema'
import { buildListColumns } from 'lib/generator'

import ArtworkThumbnail from './ArtworkThumbnail'

import './ArtworkList.css'

const fields = ['name', 'status', 'description']

const options = {
  description: {
    grow: true,
    buildCell: (text) => truncate(text, 100)
  }
}

const columns = buildListColumns(fields, options, Artwork)

columns.push({
  key: columns.length,
  dataField: 'artwork',
  dataLabel: '',
  buildCell: (src) => <ArtworkThumbnail src={src} />
})

class ArtworkList extends Component {
  constructor (props) {
    super(props)
    this.handleRowToggle = this.handleRowToggle.bind(this)
  }

  handleRowToggle (row, toggled, count) {
    const { data, onRowToggle } = this.props

    if (row === 0) {
      data.forEach((i, idx) => onRowToggle(idx + 1, toggled, count))
    } else {
      onRowToggle(row, toggled, count)
    }
  }

  render () {
    const { data, onRowToggle, ...rest } = this.props

    data.forEach(row => {
      row.artwork = ArtworkStatic.getImageURL(row.id)
    })

    return (
      <List
        data={data}
        columns={columns}
        onRowToggle={this.handleRowToggle}
        {...rest}
      />
    )
  }
}

export default ArtworkList



// WEBPACK FOOTER //
// ./src/containers/Artworks/ArtworkList.js